import type { WorkflowInput } from "@/stores/workflowsStore";
import { createContext, useContext } from "react";

/**
 * Context for providing the workflow's inputSchema to variable picker fields.
 * Avoids threading inputSchema through FormField → VariableInput/VariableTextarea/ColorInput.
 * Input schema fields appear as {{root.input.<key>}} variables in the picker.
 */
export const InputSchemaContext = createContext<WorkflowInput[] | undefined>(undefined);
export function useInputSchema() {
  return useContext(InputSchemaContext);
}